"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function capitalDashCase(s) {
    return s.replace(/([A-Z])/g, '-$1').toUpperCase();
}
exports.default = capitalDashCase;
